import { afterAttack, afterCombat, beforeOwnAttack, cardRef, defineGameCard, } from '../authoring/index.js';
import { growthOf, isLiveOnBoard, PLANT_GROWTH_ID, removeGrowth, } from './plant-helpers.js';
const ATTACK_BONUS_KEY = 'flytrapAttackBonus';
/**
 * Венерина мухоловка тратит Рост перед каждой своей обычной/дополнительной
 * атакой ради +2 только этой attack group, затем после боя пожирает ослабленную
 * карту напротив.
 */
export const VenusFlytrapCard = defineGameCard({
    id: 'venus_flytrap',
    gameplay: {
        type: 'UNIT',
        cost: 3,
        baseStats: { attack: 2, health: 4 },
        traits: ['PLANT'],
    },
    presentation: {
        name: 'Венерина мухоловка',
        description: 'Перед своей атакой тратит 1 Рост и получает +2 к атаке для этой атаки. После боя пожирает карту напротив, если у неё осталось не больше 3 здоровья.',
        glyph: {
            colors: ['#344723', '#10213A', '#7B9F31', '#961425', '#6C0E1F'],
            rows: [
                '....................',
                '..1.2..........2....',
                '..1.2.........222...',
                '.233312......233312.',
                '.2334412....2343332.',
                '.2314442....2444332.',
                '213444452..254443312',
                '213444452..254443312',
                '.234444552255444332.',
                '.233445552255544332.',
                '.213345552255543312.',
                '..2133355555533312..',
                '...22111455411122...',
                '.....2221111222.....',
                '........2212........',
                '....2112.312.3112...',
                '....213123121312....',
                '.....2231312322.....',
                '.......222222.......',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('venus_flytrap'), cardRef(PLANT_GROWTH_ID)],
    abilities: [
        beforeOwnAttack((ctx) => {
            const self = ctx.self;
            if (!isLiveOnBoard(self) || !ctx.q.canAttack(self.id) || growthOf(ctx, self.id) < 1)
                return;
            removeGrowth(ctx, self.id, 1, 'devour');
            ctx.ops.addEffect({
                defId: VenusFlytrapCard.id,
                scope: { kind: 'unit', instanceId: self.id },
                sourceId: self.id,
                duration: 1,
                persistent: true,
                vars: { [ATTACK_BONUS_KEY]: true },
                statMods: [{ stat: 'attack', op: 'add', value: 2 }],
            });
        }),
        afterAttack((ctx, event) => {
            const self = ctx.self;
            if (self === undefined || event.attackerId !== self.id)
                return;
            const bonus = ctx.q.effectsOn({ kind: 'unit', instanceId: self.id })
                .find((effect) => effect.defId === VenusFlytrapCard.id && effect.vars[ATTACK_BONUS_KEY] === true);
            if (bonus !== undefined)
                ctx.ops.removeEffect(bonus.id);
        }),
        afterCombat((ctx) => {
            const self = ctx.self;
            if (!isLiveOnBoard(self))
                return;
            const preyId = ctx.q.opposingCell(self.cellId)?.occupantId ?? null;
            if (preyId === null)
                return;
            const prey = ctx.q.instance(preyId);
            if (!isLiveOnBoard(prey)
                || prey.controllerId === self.controllerId
                || ctx.q.stats(prey.id).health > 3)
                return;
            ctx.ops.destroy(prey.id, { sourceId: self.id });
        }),
    ],
    ui: { mechanics: ['growth', 'devour'] },
});
//# sourceMappingURL=venus_flytrap.js.map